// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3i9_n","col":"CardReaderDesc_col__ex2v5","label":"CardReaderDesc_label__24198"};